/**
 * ISO 3166-1 alpha-2 country code → display name + flag emoji.
 *
 * The flag is derived from the code via regional-indicator symbols, so every
 * valid two-letter code yields a flag without a lookup table. The name table
 * covers the countries most likely to appear; unknown codes fall back to the
 * raw code as the name (the ISO badge in the UI always shows the code anyway).
 */

const NAMES: Record<string, string> = {
  IT: 'Italy', DE: 'Germany', FR: 'France', ES: 'Spain', PT: 'Portugal',
  NL: 'Netherlands', BE: 'Belgium', LU: 'Luxembourg', AT: 'Austria', CH: 'Switzerland',
  IE: 'Ireland', GB: 'United Kingdom', DK: 'Denmark', SE: 'Sweden', NO: 'Norway',
  FI: 'Finland', PL: 'Poland', CZ: 'Czechia', SK: 'Slovakia', HU: 'Hungary',
  RO: 'Romania', BG: 'Bulgaria', GR: 'Greece', HR: 'Croatia', SI: 'Slovenia',
  EE: 'Estonia', LV: 'Latvia', LT: 'Lithuania', CY: 'Cyprus', MT: 'Malta',
  US: 'United States', CA: 'Canada', BR: 'Brazil', MX: 'Mexico',
  IN: 'India', CN: 'China', JP: 'Japan', KR: 'South Korea', SG: 'Singapore',
  AE: 'United Arab Emirates', IL: 'Israel', TR: 'Türkiye', ZA: 'South Africa',
  AU: 'Australia', NZ: 'New Zealand',
};

/** Country display name for an ISO code (falls back to the code itself). */
export function countryName(code: string): string {
  return NAMES[code] || code;
}

/** Flag emoji for an ISO alpha-2 code; '🏳️' for the unknown placeholder. */
export function countryFlag(code: string): string {
  if (!/^[A-Za-z]{2}$/.test(code)) return '🏳️';
  const cc = code.toUpperCase();
  const A = 0x1f1e6;
  return String.fromCodePoint(A + (cc.charCodeAt(0) - 65), A + (cc.charCodeAt(1) - 65));
}
